import {ModifierGroupFragment} from '../../../gql/graphql';
import {ModifierModel} from './Modifier.model';
import {MAX_ITEM_OPTION_LENGTH} from '../../../common/constants';

export class ModifierGroupModel {
  public id: string;
  public name?: string;
  public modifiers: string[];

  constructor(modifierGroup: ModifierGroupFragment) {
    this.id = modifierGroup.id!;
    this.name = modifierGroup.name?.translated ?? modifierGroup.name?.original ?? /* istanbul ignore next */ undefined;
    this.modifiers = modifierGroup.modifiers
      ? ModifierModel.convertToStringArray(modifierGroup.modifiers, MAX_ITEM_OPTION_LENGTH)
      : /* istanbul ignore next */ [];
  }
}
